// Section 12: Wasting. From 4+ seasons hungry; lasts until fed 3 seasons (2 treated);
// death 15% per season; not contagious. Constants: config.illnesses.wasting.
import type { Config } from '../../config';
import { noDeltas } from '../../core/content-helpers';
import { defineIllness, noModifiers } from '../../core/registry';

export function wasting(config: Config) {
  const c = config.illnesses.wasting;

  return defineIllness({
    id: 'wasting',
    label: 'Wasting',
    section: 'S12',
    source: 'hunger',
    weight: c.weight,
    untreatedSeasons: c.untreated,
    treatedSeasons: c.treated,
    deathChance: c.death,
    contagious: false,
    modifierTargets: [],
    modifiers: noModifiers,
    onCatch: (ctx, person) => [
      { kind: 'memory', personId: person.id, entry: { turn: ctx.season.turn, kind: 'fell-ill' } },
    ],
    onRecover: noDeltas,
  });
}
